module.exports = __webpack_public_path__ + "img/logo1.b9044dfd.png";